import { MouseEvent, useContext, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TitleBar } from "../../../configs/productOrder";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ButtonRow, StyledButton, TitleText, TitleWrapper } from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import ExportManufacturingScheduleModal from "../../SaleOrder/detail/ExportManufacturingScheduleModal";
import {
    RESERVE_CREATE_ROLES,
} from "../../ReserveOrder/utils";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER, ROLE.SALE_STAFF, ROLE.SALE_MANAGER, ROLE.LOGISTIC_MANAGER].includes(role);
    const canCreateReserve = RESERVE_CREATE_ROLES.includes(role);
    const canCreateAnyOrder = canCreate || canCreateReserve;
    const canExport = [ROLE.MANAGER, ROLE.PRODUCTION_STAFF, ROLE.FACTORY_MANAGER_ONE, ROLE.FACTORY_MANAGER_TWO, ROLE.DEPUTY_FACTORY_MANAGER_ONE, ROLE.DEPUTY_FACTORY_MANAGER_TWO, ROLE.LOGISTIC_MANAGER].includes(role);
    const [openExportManufacturingModal, setOpenExportManufacturingModal] = useState(false);
    const [createMenuAnchor, setCreateMenuAnchor] =
        useState<null | HTMLElement>(null);
    const isCreateMenuOpen = Boolean(createMenuAnchor);

    const openCreateMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setCreateMenuAnchor(event.currentTarget);
    };

    const closeCreateMenu = () => {
        setCreateMenuAnchor(null);
    };

    const createSaleOrder = () => {
        closeCreateMenu();
        navigate("/product-orders/create");
    };

    const createReserveOrder = () => {
        closeCreateMenu();
        navigate("/product-orders/create?type=RESERVE");
    };

    return (
        <>
            {openExportManufacturingModal && (
                <ExportManufacturingScheduleModal
                    open={openExportManufacturingModal}
                    onClose={() => setOpenExportManufacturingModal(false)}
                />
            )}
            <TitleWrapper>
                <TitleText data-testid="page-title">{TitleBar.title}</TitleText>
                <ButtonRow>
                    {canExport && (
                        <StyledButton
                            variant="text"
                            onClick={() => setOpenExportManufacturingModal(true)}
                        >
                            Xuất lịch sản xuất
                        </StyledButton>
                    )}
                    {canCreateAnyOrder && (
                        <>
                            <StyledButton
                                data-testid="create-product-orders-button"
                                variant="contained"
                                onClick={openCreateMenu}
                                aria-controls={
                                    isCreateMenuOpen
                                        ? "create-product-order-menu"
                                        : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={
                                    isCreateMenuOpen ? "true" : undefined
                                }
                            >
                                <AddIcon />
                                Tạo đơn hàng
                                <ArrowDropDownIcon fontSize="small" />
                            </StyledButton>
                            <Menu
                                id="create-product-order-menu"
                                anchorEl={createMenuAnchor}
                                open={isCreateMenuOpen}
                                onClose={closeCreateMenu}
                            >
                                {canCreate && (
                                    <MenuItem
                                        data-testid="create-sale-order-menu-item"
                                        onClick={createSaleOrder}
                                    >
                                        Đơn bán hàng
                                    </MenuItem>
                                )}
                                {canCreateReserve && (
                                    <MenuItem
                                        data-testid="create-reserve-order-button"
                                        onClick={createReserveOrder}
                                    >
                                        Đơn dự phòng
                                    </MenuItem>
                                )}
                            </Menu>
                        </>
                    )}
                </ButtonRow>
            </TitleWrapper>
        </>
    );
};

export default Title;
